export const initPaginationState = {
  perPage: 15,
  page: 1,
  total: 1,
  sort: 0,
  ascending: 1
};